
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users",
      function () {
        return require("private-next-pages/users.js");
      }
    ]);
  